import Home from '@components/LocalMerchant/Home'
import JiaMengHeader from '@components/JiaMeng/Header/Home'

export default {
  path: 'home',
  component: JiaMengHeader,
  indexRoute: {
    component: Home
  },
  stat: '首页'
}
